import UserContext from "./context";
import StoreTemplate from "../StoreTemplate";

export default class UserStore extends StoreTemplate {
  constructor(props) {
    super(props, UserContext);
    // Dev-only bootstrap, see src/devUser.js — pre-fills the store so a
    // protected route can be opened directly instead of walking the funnel.
    if (window.__UserData__) {
      this.state = { user: window.__UserData__ };
    }
  }

  state = {};

  setUser(data) {
    return this.setState({ user: data });
  }

  setValue(param, value) {
    return this.setState({ [param]: value });
  }

  render() {
    return super.render(this.props.children);
  }
}
